// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__aNwhl","copy":"Home_copy__b6a9n","hand":"Home_hand__HQYY5","wave":"Home_wave__eb3wd"};